<template>
    <section class="top-header-new">
        <figure>
            <img src="../../../../assets/images/test/test2.gif" class="w-100 d-none d-md-block" alt="">
            <img src="../../../../assets/images/test/advertiseMobile.09d1d291.gif" class="w-100 d-block d-md-none"
                alt="">
        </figure>
        <div class="container top-header-new-content">
            <sotialNetworks class="d-lg-inline-block d-none sotial-networks-header" />
            <div class="d-flex align-items-center">
                <h6 class="m-0  title">Limited Offer: Free shipping on orders over $50</h6>
                <nav class=" d-lg-inline-block d-none">
                    <ul>
                        <li class="m-0 ">
                            <router-link class="" to="/" target="_blank">item1</router-link>
                        </li>
                        <li class="m-0 ">
                            <router-link class="" to="/" target="_blank">item2</router-link>
                        </li>
                        <li class="m-0 ">
                            <router-link class="" to="/" target="_blank">item3</router-link>
                        </li>
                        <li class="m-0 ">
                            <router-link class="" to="/" target="_blank">item4</router-link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </section>
</template>
<script>
import sotialNetworks from './sotialNetworks.vue';
export default {
    components: { sotialNetworks },
}
</script>

<style>
.sotial-networks.sotial-networks-header a svg>path {
    fill: #000 !important;
}

.sotial-networks.sotial-networks-header a:hover svg>path {
    fill: #000 !important;
}
</style>
<style scoped>
.title {
    margin-left: 16px !important;
    padding-left: 16px;
    border-left: 1px solid #e4e4e7;
    font-size: 15px;

}

ul {
    list-style-type: none;
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 0;
}

ul li a {
    color: #000;
    font-size: 15px;
}

.top-header-new {
    /*background-color: var(--color-theme);*/
    background-color: #fff;
    border-bottom: 1px solid #e4e4e7;

}

.top-header-new-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    width: 100%;

}

@media screen and (max-width:1024px) {
    .top-header-new-content {
        align-items: center;
        justify-content: center;

    }
}
</style>